import { isAnyOf, Middleware } from "@reduxjs/toolkit";
import { State } from "../state/types";
import { getSteps } from "components/Signup/steps";
import { updateActiveStep } from "../slices/navigation";
import { trackSignupEvent } from "components/Signup/analytics";
import Router from "next/router";
import { parseUrl } from "components/Signup/flow/utils/parseUrlQuery";
import { allAnimalRoutes } from "./utils/updateRoute";

const steps = getSteps();

export const analyticsMiddleware: Middleware<{}, State> =
  (storeApi) => (next) => async (action) => {
    const result = next(action);

    if (isAnyOf(updateActiveStep)(action)) {
      const state = storeApi.getState();

      const { activeStep } = state.navigation;

      const { animalId } = parseUrl(Router.query);

      if (allAnimalRoutes.includes(activeStep) && !animalId) {
        return result;
      }

      trackSignupEvent(
        activeStep,
        steps.findIndex((step) => step.name === activeStep),
        state
      );
    }

    return result;
  };
